module.exports = __webpack_public_path__ + "img/btn@2x_1.8443a7bf.png";